import(/* webpackMode: "eager" */ "/home/ec2-user/workspace/OPAM-project/frontend-next/src/app/error.tsx");
